module.exports = __webpack_public_path__ + "img/certificadocorporatevision.ee87f8f3.png";